import { render, staticRenderFns } from "./BannerImage.vue?vue&type=template&id=d4ca38cc&"
import script from "./BannerImage.vue?vue&type=script&lang=js&"
export * from "./BannerImage.vue?vue&type=script&lang=js&"
import style0 from "./BannerImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports